import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ISupportNotification, SupportState } from './reducers';

/**
 * Selector for getting the support state.
 */
export const getSupportState = createFeatureSelector<SupportState>('support');

/**
 * Selectors for the support feature.
 */
export class SupportSelectors {
  /**
   * Selector for getting whether the support feature is initialized.
   */
  static getSupportInititalized = createSelector(getSupportState, (state: SupportState) => state.isInitialized);

  /**
   * Selector for getting the support requests dashboard data.
   */
  static getSupportRequestsDashboardData = createSelector(
    getSupportState,
    (state: SupportState) => state.dashboardData
  );

  /**
   * Selector for getting the date when the support requests grid data was last updated.
   */
  static getLastUpdated = createSelector(getSupportState, (state: SupportState) => state.lastUpdated);

  /**
   * Selector for getting the support requests.
   */
  static getSupportRequestChanged = createSelector(
    getSupportState,
    (state: SupportState) => state.supportRequestChanged
  );

  /**
   * Selector for getting the support requests assigned to current user
   */
  static getAssignedSupportRequests = createSelector(
    getSupportState,
    (state: SupportState) => state.assignedSupportRequests
  );
  /**
   * Get showing notification state
   */
  static getShowingNotification = createSelector(getSupportState, (state: SupportState) => state.showingNotification);
  /**
   * Get showing notification requests
   */
  static getShowingNotificationRequests = createSelector(
    this.getShowingNotification,
    (state: ISupportNotification) => state.supportRequests
  );
  
  /**
   * Get support request data filter
   */
  static supportRequestDataFilterOption = createSelector(
    getSupportState,
    (state: SupportState) => state.supportRequestFilterOption
  );

  /**
   * Get support request chart toggle
   */
  static supportRequestShowChartToggle = createSelector(
    getSupportState,
    (state: SupportState) => state.supportRequestChartToggle
  );
}
